import React from "react";
import Reveal from "./Reveal";

const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative bg-white pt-20 md:pt-28 pb-16 md:pb-24 border-t border-black/10"
    >
      <div className="px-6 md:px-12 lg:px-16">
        {/* Heading */}
        <div className="grid grid-cols-12 gap-6 mb-10 md:mb-14">
          <div className="col-span-12 md:col-span-8">
            <p className="flex items-center gap-2 text-[12px] tracking-[0.28em] uppercase font-bold text-[#E60000] mb-4">
              <span className="w-1.5 h-1.5 rounded-full bg-[#E60000]" />
              Final CTA
            </p>
            <Reveal>
              <h2
                data-testid="contact-heading"
                className="font-display font-black uppercase text-[32px] sm:text-[44px] md:text-[60px] lg:text-[72px] leading-[0.95] tracking-[-0.03em] text-black text-balance"
              >
                Let's build
                <br />
                something that
                <br />
                actually works
                <span className="text-[#E60000]">.</span>
              </h2>
            </Reveal>
          </div>
        </div>

        {/* Contact info rows — same style as the old form fields */}
        <div className="border-t border-black/20">
          {/* Name */}
          {/* <div className="border-b border-black/20 py-4 md:py-5">
            <p className="text-[10px] md:text-[11px] tracking-[0.28em] uppercase font-bold text-[#E60000] mb-2 md:mb-3">
              Contact
            </p>
            <p className="font-display font-black uppercase tracking-tight text-lg md:text-2xl lg:text-3xl text-black">
              Vamsi
            </p>
          </div> */}

          {/* Phone */}
          <div className="border-b border-black/20 py-4 md:py-5">
            <p className="text-[10px] md:text-[11px] tracking-[0.28em] uppercase font-bold text-[#E60000] mb-2 md:mb-3">
              Phone No.
            </p>
            <a
              href="tel:+917075772733"
              className="font-display font-black uppercase tracking-tight text-lg md:text-2xl lg:text-3xl text-black hover:text-[#E60000] transition-colors duration-150 block"
            >
              +91 70757 72733 / +91 8106600391
            </a>
          </div>

          {/* Email */}
          <div className="border-b border-black/20 py-4 md:py-5">
            <p className="text-[10px] md:text-[11px] tracking-[0.28em] uppercase font-bold text-[#E60000] mb-2 md:mb-3">
              Email
            </p>
            <a
              href="mailto:dotmedia.co.in@gmail.com"
              className="font-display font-black uppercase tracking-tight text-lg md:text-2xl lg:text-3xl text-black hover:text-[#E60000] transition-colors duration-150 block break-all"
            >
              dotmedia.co.in@gmail.com
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
